import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Article from './pages/Article';
import DetailArticlePage from './pages/DetailArticle';
import SearchResult from './pages/SearchResult';
import Video from './pages/Video';
import './style.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="app-container">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/article" element={<Article />} />
              <Route path="/video" element={<Video />} />
              <Route path="/:type/:slug" element={<DetailArticlePage />} />
              <Route path="/search" element={<SearchResult />} />
            </Routes>
          </main>
          <Navbar />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
